import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-88548166"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icons" }



import EventIcon from '@/components/atoms/EventIcon.vue'
import VueI18n from 'vue-i18n'

type PropsType = {
  icons?: { icon: string; text: VueI18n.TranslateResult }[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EventIcons',
  props: {
    icons: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.icons, (icon) => {
      return (_openBlock(), _createBlock(EventIcon, {
        key: icon.icon,
        "event-type": icon.icon,
        "event-type-text": icon.text
      }, null, 8, ["event-type", "event-type-text"]))
    }), 128))
  ]))
}
}

})